import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useRecordContext,
    required,
    SelectInput,
    minValue,
    useDataProvider,
    DataProviderContext,
    NumberInput,
} from 'react-admin';

import { Ecom_Product_Templates } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';

import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { STATUSES } from '../../common/constants';
import { createCustomGoDataProvider } from '../../services';

const ProductTemplateEdit = () => {
    let { categoryId, productTemplateId } = useParams();
    if (!productTemplateId) {
        return <LoadingSection />;
    }
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_product_templates', apiEndpoint: '/ecom/product-templates' },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <Edit
                title={<ProductTemplateTitle />}
                redirect={() => {
                    return `ecom_categories/${categoryId}/ecom_product_templates`;
                }}
                resource={'ecom_product_templates'}
                id={productTemplateId}
                mutationMode={'pessimistic'}
            >
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload type="VIDEO_THUMBNAIL" source="images" multiple />
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <NumberInput
                        source="heightInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <SelectInput
                        source="status"
                        label={'Status'}
                        fullWidth
                        validate={[required()]}
                        choices={STATUSES}
                    />
                    <NumberInput
                        source="widthInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        source="lengthInMtr"
                        prefix={'In Meters'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        source="weightInGrams"
                        prefix={'In Grams'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <TextInput
                        source="textDescription"
                        multiline
                        rows={4}
                        fullWidth
                        validate={[required()]}
                    />
                    <HTMLEditorInput
                        source={'htmlDescription'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Edit>
        </DataProviderContext.Provider>
    );
};

const ProductTemplateTitle = () => {
    const record = useRecordContext<Ecom_Product_Templates>();
    return record ? <span>{record.name}</span> : null;
};

export default ProductTemplateEdit;
